module.exports = __webpack_public_path__ + "img/rudbeckia.78988070.jpg";